import React, { useEffect } from "react";
import { X, Play } from "lucide-react";
import { HeroCarousel } from "./HeroCarousel";

/**
 * Lightweight 90s product-tour modal.
 * Since there's no recorded video yet, we replay the hero carousel inside
 * the modal at a larger size — same content, same narrative, no asset gap.
 */
export const VideoModal = ({ open, onClose }) => {
    useEffect(() => {
        if (!open) return undefined;
        const onKey = (e) => {
            if (e.key === "Escape") onClose();
        };
        document.addEventListener("keydown", onKey);
        document.body.style.overflow = "hidden";
        return () => {
            document.removeEventListener("keydown", onKey);
            document.body.style.overflow = "";
        };
    }, [open, onClose]);

    if (!open) return null;

    return (
        <div
            className="video-modal-backdrop"
            role="dialog"
            aria-modal="true"
            aria-label="Product tour"
            onClick={onClose}
            data-testid="video-modal"
        >
            <div className="video-modal" onClick={(e) => e.stopPropagation()}>
                <button
                    type="button"
                    className="video-modal-close"
                    onClick={onClose}
                    aria-label="Close product tour"
                    data-testid="video-modal-close"
                >
                    <X size={18} />
                </button>
                <div className="video-modal-head">
                    <span className="eyebrow">90-second product tour</span>
                    <h3 className="h3" style={{ marginTop: 8 }}>Standalone products — in motion</h3>
                </div>
                <div className="video-modal-stage">
                    <HeroCarousel />
                </div>
            </div>
        </div>
    );
};

export const VideoTriggerButton = ({ onClick }) => (
    <button type="button" className="btn btn-ghost btn-lg" onClick={onClick} data-testid="hero-video-trigger">
        <Play size={16} fill="currentColor" /> Watch 90-sec tour
    </button>
);

export default VideoModal;
